import {
  FETCH_CONNECTIONS,
  FILTER_CONNECTIONS
} from "./actionTypes";
import axios from "axios";
import { CONNECTIONS_URL } from "../../config";

/**
 * Pobieranie listy połączeń z serwera
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchConnections = callback => {
  return dispatch => {
    return axios
      .get(CONNECTIONS_URL)
      .then(response => {
        dispatch(fetchConnectionsSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Filtrowanie połączeń
 * 
 * @param {connectionType} filter filtr typu połączeń
 */
export const filterConnections = filter => {
  return dispatch => {
    dispatch(filterConnectionsSuccess(filter));
  };
};

/**
 * Na żądanie - wysłanie prośby do połączenia o licencję
 * 
 * @param connectionId identyfikator połączenia do którego wysyłamy żądanie
 */
export const licenseRequest = connectionId => {
  return dispatch => {
    return axios
      .put(`${CONNECTIONS_URL}/${connectionId}/license`)
      .then(response => {
        //to tylko żądanie, jeśli uzyskamy odpowiedź - przyjdzie w danych połączenia
      })
  };
};

/**
 * Na żądanie - wysłanie prośby do połączenia o status update-service
 * 
 * @param connectionId identyfikator połączenia do którego wysyłamy żądanie
 */
export const updateServiceStatusRequest = connectionId => {
  return dispatch => {
    return axios
      .put(`${CONNECTIONS_URL}/${connectionId}/updateService/status`)
      .then(response => {
        //to tylko żądanie, jeśli uzyskamy odpowiedź - przyjdzie w danych połączenia
      })
  };
};

/**
 * Na żądanie - wysłanie prośby do połączenia o reinstalację update-service
 * 
 * @param connectionId identyfikator połączenia do którego wysyłamy żądanie
 */
export const updateServiceReinstallRequest = connectionId => {
  return dispatch => {
    return axios
      .put(`${CONNECTIONS_URL}/${connectionId}/updateService/reinstall`)
      .then(response => {
        //to tylko żądanie, jeśli uzyskamy odpowiedź - przyjdzie w danych połączenia
      })
  };
};

/**
 * Akcja pomyślnego pobrania połączeń 
 * 
 * @param {object} data Obiekt listy połączeń
 */
export const fetchConnectionsSuccess = data => {
  return {
    type: FETCH_CONNECTIONS,
    payload: data
  };
};

/**
 * Akcja pomyślnego filtrowania połączeń 
 * 
 * @param {object} data Obiekt wybranego filtra
 */
export const filterConnectionsSuccess = data => {
  return {
    type: FILTER_CONNECTIONS,
    payload: data
  };
};